<template>
  <div v-if="!hasText" class="separator"/>
  <div v-else class="flex-row align-center ri-large-body">
    <div class="separator flex-1"/>
    <div class="separator-text margin-horizontal-s">{{ text }}</div>
    <div class="separator flex-1"/>
  </div>
</template>

<script>

export default {
  name: 'Separator',
  props: {
    text: {
      type: String,
      required: false,
    },
  },
  computed: {
    hasText() {
      return !!this.text && this.text.length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/riseup-colors';

.separator {
  height: 1px;
  width: 100%;
  background: $riseup_gray_0;
}

</style>
